"use client";
import React from "react";
import { Spinner } from "@heroui/spinner";
import { Pagination } from "@heroui/pagination";

import useBlog from "./useBlog";

import {
  BlogCard,
  BlogCategory,
  BlogSubscribe,
  LatestBlog,
} from "@/components";
import { AllBlogs } from "@/types";
const Blog = () => {
  const { allBlogs, blogLoading, blogRef, latestBlog, handlePageChange } =
    useBlog();
  const blogList =
    allBlogs?.data?.length > 0 ? allBlogs.data : (latestBlog?.data ?? []);

  return (
    <div className=" min-h-screen pt-10">
      <div className="max-w-screen-2xl mx-auto lg:px-28 px-6">
        <div className="italic text-2xl text-primary font-medium">Blog</div>
        <div className="">
          {blogLoading ? (
            <div className="flex items-center justify-center  h-screen-60 ">
              <Spinner />
            </div>
          ) : (
            <div>
              {allBlogs?.data?.length > 0 && <LatestBlog />}
              <div ref={blogRef}>
                <BlogCategory />
              </div>
              {blogList?.length > 0 ? (
                <>
                  <div className="mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                    {blogList?.map((blog: AllBlogs) => (
                      <BlogCard key={blog._id} data={blog} />
                    ))}
                  </div>
                  <Pagination
                    showControls
                    classNames={{
                      base: "flex items-center justify-center mt-10",
                    }}
                    page={allBlogs?.page}
                    total={allBlogs?.totalPages}
                    onChange={handlePageChange}
                  />
                </>
              ) : (
                <div className="flex items-center justify-center h-screen-60 w-full text-sm text-foreground">
                  No Blog found
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <BlogSubscribe />
    </div>
  );
};

export default Blog;
